import { css } from 'linaria';
import { resetOnboarding } from 'connectors/onboarding/onboarding.state';
import { useDispatch } from 'react-redux';
const resetStyles = "ru8lzzc";
export const Resets = () => {
  const dispatch = useDispatch();

  const onboardingReset = () => dispatch(resetOnboarding());

  return <div className={resetStyles}>
      <h6>Account Resets</h6>
      <div className="resetter" onClick={onboardingReset}>
        <div className="title">Reset Onboarding</div>
        <div className="description">Start onboarding from the start</div>
      </div>
    </div>;
};

require("../../../.linaria-cache/src/connectors/dev-tools/resets.linaria.module.css");